import React, { useState, useEffect, useRef } from 'react';
import '../NewPostForm.css';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import MentionTextarea from "./MentionTextarea";

const MySwal = withReactContent(Swal);

const frames = [
    { file: 'frame_heart.png', label: 'Srdce' },
    { file: 'frame_star.png', label: 'Hvězda' },
    { file: 'frame_glow.png', label: 'Záře' }
];

const filters = [
    { id: 'grayscale', label: 'Černobílý', unit: '%', min: 0, max: 100, default: 0 },
    { id: 'sepia', label: 'Sepia', unit: '%', min: 0, max: 100, default: 0 },
    { id: 'blur', label: 'Rozmazání', unit: 'px', min: 0, max: 10, default: 0 },
    { id: 'invert', label: 'Invert barvy', unit: '', min: 0, max: 1, default: 0, step: 0.1 },
    { id: 'saturate', label: 'Sytost', unit: '%', min: 0, max: 500, default: 100 },
    { id: 'contrast', label: 'Kontrast', unit: '%', min: 0, max: 300, default: 100 },
    { id: 'brightness', label: 'Jas', unit: '%', min: 0, max: 300, default: 100 },
];

const feelings = ['😊 Vesele', '😡 Naštvaně', '😂 Pobaveně', '🤢 Znechuceně', '😜 Hravě', '😚 Roztomile', '😍 Zamilovaně', '😱 Vystrašeně', '🤩 Natěšeně', '😢 Smutně', '🌟 Fantasticky', '😌 Uvolněně', '🎉 Slavnostně', '☕ Nostalgicky', '😌 Spokojeně', '🔥 Žhavě', '😴 Unaveně', '👀 Zvědavě', '🤔 Zamyšleně', '😔 Osaměle', '🥺 Nevinně', '🤤 Mlsně', '🥶 Zmrzle', '💩 Na hovno', '🤡 Jako debil', '👽 Úplně mimo', '🍬 Sladce', '🍻 Opile', '🍔 Hladově', '⚽️ Sportovně', '🌞 Jako sluníčko', '🧠 Bez mozku', '👑 Jako King', '👑 Jako Queen'];
const allowedEmojis = [
    '😈', '🤖', '👻', '🧠', '💥', '🌈', '🔥', '🌙', '🍕', '🍷', '💀', '🎯', '🎮', '💤', '✨', '🚀', '📸','😀','😄','😁','😆','🥹','😅','😂','🥲','😊','🙃','🙂','😇','😍','😌','😉','😘','😜','😝','😛','😎','🤓','🧐','🤨','🥸','🤩','🥳','🙂‍↕️','🥺','😩','😢','😭','😡','😱','😨','🤗','😓','😥','🫣','🤭','🤫','🫢','🫡','🤥','🫠','🫥','😬','🫨','🙄','😲','😴','🤕'
];

const NewPostForm = ({ avatar, onNewPost  }) => {
    const modalRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [text, setText] = useState('');
    const [tags, setTags] = useState('');
    const [feeling, setFeeling] = useState('');
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [frame, setFrame] = useState('');
    const [tagInput, setTagInput] = useState('');
    const [parsedTags, setParsedTags] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [trend, setTrend] = useState([]);
    const [goldTrend, setGoldTrend] = useState([]);
    const [customEmoji, setCustomEmoji] = useState(allowedEmojis[0]);
    const [customFeeling, setCustomFeeling] = useState('');
    const [showEditPanel, setShowEditPanel] = useState(false);
    const [filterValues, setFilterValues] = useState(() => {
        const initial = {};
        filters.forEach(f => initial[f.id] = f.default);
        return initial;
    });

    const updateFilterValue = (id, value) => {
        setFilterValues(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const getCssFilterString = () => {
        return Object.entries(filterValues)
            .map(([id, value]) => {
                const f = filters.find(f => f.id === id);
                return `${id}(${value}${f.unit})`;
            })
            .join(' ');
    };

    useEffect(() => {
        const fetchTrend = async () => {
            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/trend.php", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' }
                });
                const data = await res.json();
                if (data.status === 'success' && Array.isArray(data.trend)) {
                    setTrend(data.trend);
                    setGoldTrend(data.gold);
                }
            } catch (error) {
                console.error('Chyba při načítání trendu:', error);
            }
        };

        fetchTrend();
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (open && modalRef.current && !modalRef.current.contains(e.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const isValidPost = () => {
        return text.trim() !== '' || image !== null;
    };

    const uploadToImgur = async (base64Data) => {
        const formData = new FormData();
        formData.append("image", base64Data.split(',')[1]);

        const response = await fetch("https://api.imgur.com/3/image", {
            method: "POST",
            headers: {
                Authorization: "Client-ID 802dc556f40f25f"
            },
            body: formData
        });

        const data = await response.json();
        return data.success ? data.data.link : null;
    };

    const generateFinalImage = async () => {
        if (!imagePreview) return null;

        const loadImage = (src) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.src = src;
            });
        };

        const toDataURL = async (url) => {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });
        };


        const baseImage = await loadImage(imagePreview);
        const canvas = document.createElement('canvas');
        canvas.width = baseImage.width;
        canvas.height = baseImage.height;
        const ctx = canvas.getContext('2d');

        ctx.filter = getCssFilterString();

        ctx.drawImage(baseImage, 0, 0);

        if (frame) {
            const frameDataUrl = await toDataURL(`https://echo.fantasyworldtrpg.cz/img/${frame}`);
            const frameImg = await loadImage(frameDataUrl);
            ctx.drawImage(frameImg, 0, 0, canvas.width, canvas.height);
        }

        return canvas.toDataURL('image/png');
    };


    const handleTagInput = (e) => {
        const value = e.target.value;
        if (value.endsWith(' ')) {
            const tag = value.trim();
            if (tag && !parsedTags.includes(tag)) {
                setParsedTags([...parsedTags, tag]);
            }
            setTagInput('');
        } else {
            setTagInput(value);
        }
    };

    const removeTag = (tagToRemove) => {
        setParsedTags(parsedTags.filter(tag => tag !== tagToRemove));
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') setOpen(false);
    };

    useEffect(() => {
        if (open) {
            document.addEventListener('keydown', handleKeyDown);
        } else {
            document.removeEventListener('keydown', handleKeyDown);
        }
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [open]);

    const submitPost = async () => {
        if (!isValidPost()) {
            await MySwal.fire({
                icon: 'warning',
                title: 'Chybí obsah',
                text: 'Musíš napsat příspěvek nebo přidat obrázek.'
            });
            return;
        }

        if (isSubmitting) return;
        setIsSubmitting(true);

        const uid = localStorage.getItem("echo_user");
        if (!uid) {
            alert("Chybí identifikace uživatele.");
            setIsSubmitting(false);
            return;
        }

        let imageUrl = null;

        try {
            if (image) {
                const finalImage = await generateFinalImage();
                if (!finalImage) throw new Error("Chyba při generování obrázku.");
                imageUrl = await uploadToImgur(finalImage);
                if (!imageUrl) throw new Error("Nepodařilo se nahrát obrázek.");
            }
            const finalFeeling = feeling === 'custom'
                ? `${customEmoji} ${customFeeling}`
                : feeling;

            const postData = {
                uid,
                text,
                image: imageUrl,
                tags: parsedTags,
                feeling: finalFeeling,
                filter: getCssFilterString(),
                frame,
                user: localStorage.getItem("fw_user")
            };

            const response = await fetch('https://api.fantasyworldtrpg.cz/echo/newpost.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postData)
            });
            console.log(postData)

            const data = await response.json();
            if (data.success) {
                /*const newPost = {
                    id: data.id ?? Date.now(),
                    user: uid,
                    text,
                    image: imageUrl,
                    tag: parsedTags,
                    activity: feeling,
                    filter: getCssFilterString(),
                    frame,
                    dt: new Date().toISOString()
                };*/

                onNewPost?.();

                await MySwal.fire({
                    icon: 'success',
                    title: 'Hotovo!',
                    text: 'Příspěvek úspěšně přidán.'
                });

                setOpen(false);
                setText('');
                setTags('');
                setFeeling('');
                setImage(null);
                setImagePreview(null);
                setFrame('');
                setTagInput('');
                setParsedTags([]);
            } else {
                await MySwal.fire({
                    icon: 'error',
                    title: 'Chyba',
                    text: data.message || 'Chyba při ukládání příspěvku.'
                });
            }
        } catch (err) {
            console.error(err);
            alert(err.message || "Nastala chyba při odesílání.");
        }

        setIsSubmitting(false);
    };

    return (
        <>
            <div className="d-flex align-items-center gap-2 mb-3" onClick={() => setOpen(true)} style={{ cursor: 'pointer' }}>
                <textarea type="text" style={{ resize: "none" }} className="form-control" value={text} placeholder="Co se ti honí hlavou?" readOnly />
            </div>
            {trend.length > 0 && (
                <div className="my-3">
                    <strong className="me-2">🔥 Trendy:</strong>
                    {goldTrend && (
                        <span className="badge bg-warning text-dark me-1">#{goldTrend}</span>
                    )}
                    {trend.map((t, i) => (
                        <span key={i} className="badge bg-danger me-1">#{t}</span>
                    ))}
                </div>
            )}

            {open && (
                <div className="new-post-overlay">
                    <button className="btn-close btn-close-white" onClick={() => setOpen(false)} />
                    <div className="new-post-inner" ref={modalRef}>
                        <h4 className="mb-3">Nový příspěvek</h4>

                        <textarea
                            className="form-control mb-2"
                            rows="4"
                            placeholder="Napiš něco..."
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                        />
                        {/*<MentionTextarea
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            placeholder="Napiš něco..."
                            rows={4}
                        />*/}

                        <input type="file" className="form-control mb-2" onChange={handleImageChange} />

                        {imagePreview && (
                            <div className="edit-wrapper mb-3">
                                <div style={{ flex: 2 }}>
                                    <img
                                        src={imagePreview}
                                        alt="Náhled"
                                        className="img-fluid rounded w-100"
                                        style={{ filter: getCssFilterString() }}
                                    />
                                    {frame && (
                                        <img
                                            src={`https://echo.fantasyworldtrpg.cz/img/${frame}`}
                                            alt="Rámeček"
                                            className="frame-overlay"
                                        />
                                    )}
                                    <button
                                        className="btn btn-outline-danger btn-sm mt-2"
                                        onClick={() => setShowEditPanel(prev => !prev)}
                                    >
                                        {showEditPanel ? 'Skrýt úpravy' : 'Upravit obrázek'}
                                    </button>
                                </div>

                                {showEditPanel && (
                                    <div className="edit-panel">
                                        <strong className="d-block mb-2">Úpravy obrázku:</strong>
                                        {filters.map((f) => (
                                            <div key={f.id} className="mb-2">
                                                <label className="form-label">
                                                    {f.label}: {filterValues[f.id]}{f.unit}
                                                </label>
                                                <input
                                                    type="range"
                                                    min={f.min}
                                                    max={f.max}
                                                    step={f.step || 1}
                                                    value={filterValues[f.id]}
                                                    onChange={(e) => updateFilterValue(f.id, e.target.value)}
                                                    className="form-range"
                                                />
                                            </div>
                                        ))}
                                        <button
                                            className="btn btn-sm btn-outline-secondary mt-2"
                                            onClick={() => {
                                                const reset = {};
                                                filters.forEach(f => reset[f.id] = f.default);
                                                setFilterValues(reset);
                                            }}
                                        >
                                            Obnovit filtry
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="mb-3">
                            <label>Tagy:</label>
                            <div className="form-control d-flex flex-wrap gap-1">
                                {parsedTags.map((tag, index) => (
                                    <span key={index} className="badge bg-secondary position-relative">
                                        {tag}
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white btn-sm position-absolute top-0 end-0"
                                            style={{ fontSize: '0.6rem' }}
                                            onClick={() => removeTag(tag)}
                                        />
                                    </span>
                                ))}
                                <input
                                    type="text"
                                    className="border-0 form-control flex-grow-1"
                                    placeholder="Napiš tagy a odděluj mezerou"
                                    value={tagInput}
                                    onChange={handleTagInput}
                                    style={{ outline: 'none' }}
                                />
                            </div>
                        </div>

                        <select className="form-select mb-3" value={feeling}
                                onChange={(e) => setFeeling(e.target.value)}>
                            <option value="">Žádný pocit</option>
                            <option value="custom">📝 Vlastní...</option>
                            {feelings.map((f) => (
                                <option key={f} value={f}>{f}</option>
                            ))}
                        </select>
                        {feeling === 'custom' && (
                            <div className="mb-3 d-flex gap-2">
                                <select className="form-select" value={customEmoji} onChange={(e) => setCustomEmoji(e.target.value)}>
                                    {allowedEmojis.map((emoji, i) => (
                                        <option key={i} value={emoji}>{emoji}</option>
                                    ))}
                                </select>
                                <input
                                    className="form-control"
                                    placeholder="Jak se cítíš?"
                                    value={customFeeling}
                                    onChange={(e) => setCustomFeeling(e.target.value)}
                                />
                            </div>
                        )}

                        <button className="btn btn-danger w-100" onClick={submitPost} disabled={isSubmitting}>
                            {isSubmitting ? 'Odesílání...' : 'Odeslat'}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default NewPostForm;
